export default __webpack_public_path__ + "static/media/11.16ac1ace.jpg";